/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

export type ViewContentType = (typeof ViewContentType)[keyof typeof ViewContentType];

export const ViewContentType = {
	CONTEST: 'CONTEST',
	PROGRAM: 'PROGRAM',
	PRODUCT: 'PRODUCT'
} as const;
